<template>
  <ViewCustomData entityName="property" entitySpec="facility" serviceName="BaseService"
    :columns="FACILITY_PROPERTY_COLUMNS" :dictionary="dictionary" @selectedRow="onSelectedRow" @delete="onDeleteRow"
    :masterDetail="{ facility_id: facilityId }" scrollHeight="400px" ref="viewFacilityProperty" :paginator="false"
    mode="edit" :requiredFieldsTable="FACILITY_PROPERTY_REQUIRED_FILEDS" :prepareUpdate="prepareUpdate"
    :prepareInsert="prepareInsert" :beforeOpenNewRow="beforeOpenNewRow" :prepareData="prepareData"
    @dictIsReady="dictIsReady">
    <template #toolbar>
      <div class="component-filter gap-1">
        <Button label="Заменить путь" severity="success" icon="pi pi-folder"
          style="white-space: nowrap; min-width: 140px;" :disabled="!$store.getters.info.isAdmin"
          @click="$emit('changePath')" />
        <Button label="Устройства" severity="success" icon="pi pi-cog" :disabled="!$store.getters.info.isAdmin"
          @click="$emit('changeDevice')" />
      </div>
    </template>
  </ViewCustomData>
</template>

<script setup>
import axios from 'axios';
import { ref, computed, defineProps, defineEmits } from 'vue';
import { useStore } from 'vuex';
import { FACILITY_PROPERTY_DICTIONARY, FACILITY_PROPERTY_COLUMNS, FACILITY_PROPERTY_REQUIRED_FILEDS } from './facilityConstants';

const store = useStore();
const props = defineProps(['facilityId']);
const emit = defineEmits(['selected', 'loadData', 'changePath', 'changeDevice', 'dictIsReady']);

const selected = ref(null);
const sourceIsEmpty = ref(false);
const dialogOptions = ref({});
const viewFacilityProperty = ref(null);

const addSourceFromData = (row) => ({
  source: row.property_path,
  property_path: row.property_path,
});

const loadSourceFromData = (data) => {
  const result = [];
  data.forEach((item) => {
    result.push(addSourceFromData(item));
  });
  return result;
};

const loadSource = async () => {
  const login = store.getters.info.login;
  const password = store.getters.password;
  const api = `${store.getters.server('TM_MIDDLE')}kron.tm3.service-web-1.0/webresources/restservice/opcsourcesitems/${props.facilityId}`;
  const headers = {
    Authorization: 'Basic ' + btoa(login + ':' + password),
  };
  try {
    const { data } = await axios.get(api, { headers });
    const result = [];
    if (data?.length) {
      data.forEach((element) => {
        result.push({ source: element, property_path: element });
      });
    }
    return result;
  } catch (er) {
    store.commit('SET_ERROR', {
      er: er.response || er,
      source: ['FacilityProperty', 'loadSource'],
    });
    return [];
  }
};

const dictionary = computed(() => {
  const base = [...FACILITY_PROPERTY_DICTIONARY];
  const extras = [
    {
      options: 'device',
      save: { store: false, self: true },
      load: 'db',
      params: {
        facility_id: props.facilityId,
      },
      serviceName: 'BaseService',
      entityName: 'device',
      entitySpec: 'data',
    },
    {
      options: 'source',
      save: { store: false, self: true },
      load: 'parent',
      data: loadSource,
      entityName: 'source',
    },
  ];
  return [...base, ...extras];
});

const dictIsReady = (options, data) => {
  dialogOptions.value[options] = data;
  if (options === 'device') {
    emit('dictIsReady', options, data);
  }
  if (options === 'source') {
    sourceIsEmpty.value = data.length === 0;
  }
};

const onSelectedRow = (value) => {
  selected.value = value;
  if (value?.property_type_id || value?.property_id) {
    emit('selected', {
      property_id: value.property_id,
      property_type_id: value.property_type_id,
      property_type_desc: value.property_type_desc,
    });
  }
};

const onDeleteRow = () => {
  emit('selected', {
    property_id: null,
    property_type_id: null,
    property_type_desc: null,
  });
}

const prepareUpdate = (rowData) => {
  const data = {
    property_id: rowData.property_id,
    device_id: rowData.device_id,
    facility_id: rowData.facility_id,
    active_flange_no: rowData.active_flange_no,
    property_type_id: rowData.property_type_id,
    unit_id: rowData.unit_id,
    property_path: rowData.property_path,
    property_formula: rowData.property_formula,
    property_factor: rowData.property_factor,
    property_refresh_rate: rowData.property_refresh_rate,
    property_process_rate: rowData.property_process_rate,
    property_save_rate: rowData.property_save_rate,
    property_desc: rowData.property_desc,
    property_is_visible_form: rowData.property_is_visible_form,
    property_use_source_date: rowData.property_use_source_date,
  };
  return data;
};

const prepareInsert = (rowData) => {
  delete rowData.property_is_fast;
  delete rowData.source_name;
  delete rowData.property_id;
  if (viewFacilityProperty.value?.filters?.source) {
    viewFacilityProperty.value.filters.source.push(addSourceFromData(rowData));
  }
  return rowData;
};

const beforeOpenNewRow = (rowData) => {
  rowData.facility_id = props.facilityId;
  rowData.property_id = null;
  rowData.active_flange_no = 0;
  const devices = viewFacilityProperty.value?.filters?.['device'] || [];
  rowData.device_id = devices.length ? devices[0].device_id : null;
  rowData.property_factor = 1;
  rowData.property_refresh_rate = 10;
  rowData.property_process_rate = 60;
  rowData.property_save_rate = 7200;
  rowData.property_is_visible_form = false;
  rowData.property_use_source_date = false;
};

const prepareData = (data) => {
  if (data.length) {
    if (viewFacilityProperty.value) {
      viewFacilityProperty.value.selected = data[0];
    }
    if (sourceIsEmpty.value) {
      if (viewFacilityProperty.value?.filters) {
        viewFacilityProperty.value.filters.source = loadSourceFromData(data);
      }
      sourceIsEmpty.value = false;
    }
  }
  emit('loadData', data, 'FacilityProperty');
  return data;
};
</script>